import { render } from "./post-list-page.vue?vue&type=template&id=1a45c435&ts=true"
import script from "./post-list-page.vue?vue&type=script&lang=ts"
export * from "./post-list-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__